/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {service as ConservationActionPhaseService} from "../../../Services/ConservationActionPhaseService";
import {ServiceDrivenAutoCompleteFieldEditor} from "./ServiceDrivenAutoCompleteFieldEditor";

export const ConservationActionPhaseFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ConservationActionPhaseService);
